import apiClient, {
  getAPIURL,
  markAuthSessionEstablished,
  refreshCookieAuthSession,
  requestCookieLogout,
} from "@/lib/utils/apiClient";

export {
  getAPIURL,
  markAuthSessionEstablished,
  refreshCookieAuthSession,
  requestCookieLogout,
};
export default apiClient;
